<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1340.001 -329)">
			<path
				d="M6.875,33a3.761,3.761,0,0,0,3.75,3.75h15A3.761,3.761,0,0,0,29.375,33V10.5H6.875ZM31.25,4.875H24.687L22.813,3H13.438L11.562,4.875H5v3.75H31.25Z"
				transform="translate(1344.376 331.625)"
			/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1340.001 329)" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-delete',
	components: {},
	computed: {},
	props: {}
};
</script>

<style scoped lang="scss">
.a {
	fill: none;
}
</style>

<docs>
    IconDelete

    ```js
    <b-icon-delete />
    ```
</docs>
